export default {"src":"/_next/static/media/courses.36f1d185.svg","height":500,"width":750,"blurWidth":0,"blurHeight":0};